export enum CategoryWorkflowStatus {
    ComingSoon,
    Completed,
    Blocked,
    Current,
}

export const CategoryWorkflowStatuses: { name: string, value: CategoryWorkflowStatus }[] = [
    { name: "Locked", value: CategoryWorkflowStatus.Blocked },
    { name: "Completed", value: CategoryWorkflowStatus.Completed },
    { name: "Planned", value: CategoryWorkflowStatus.ComingSoon },
];
